<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.common.filter.group_by.title') }}
        </label>
        <div class="filter__item__body">
          <select-group-by v-model="form.group_by" />
        </div>
      </div>

      <div class="filter__item filter__item--datepicker col-6">
        <label class="filter__item__title">{{ $t('shared.component.filter.period') }}</label>
        <div class="filter__item__body">
          <date-range-picker v-model="form.date" />
        </div>
      </div>
    </div>
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.common.filter.group_by.values.type') }}
        </label>
        <div class="filter__item__body">
          <select-type v-model="form.type" />
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('pbx.stat.common.filter.group_by.values.destination') }}
        </label>
        <div class="filter__item__body">
          <select-destination v-model="form.destination" />
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">{{ $t('pbx.stat.table.field.type_answer') }}</label>
        <div class="filter__item__body">
          <select-type-answer v-model="form.state" multiple />
        </div>
      </div>
      <div class="filter__item filter__item--button ml-auto ">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import SelectGroupBy from './select-group-by';
  import SelectType from '../../filters/select-type';
  import SelectDestination from '../../filters/select-destination';
  import SelectTypeAnswer from '../../filters/select-type-answer';
  import { mapActions } from 'vuex';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';

  export default {
    components: {
      FilterWrapper,
      SelectGroupBy,
      SelectType,
      SelectTypeAnswer,
      SelectDestination
    },
    data: () => ({
      form: {
        date: initSearchStateByPeriod(),
        state: '',
        group_by: 'date',
        destination: '',
        type: ''
      }
    }),

    mounted() {
      this.submit();
    },

    methods: {
      ...mapActions('pbx/stats/general/table', ['search']),

      submit() {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { state, group_by, type, destination } = this.form;
        const stateString = state.toString();

        const params = {
          date_from: start,
          date_to: end,
          timezone: this.$user.timezone,
          state: stateString,
          group_by,
          type,
          destination
        };

        this.search(params);
      }
    }
  };
</script>
